import { render, staticRenderFns } from "./menu2_active_learning.vue?vue&type=template&id=26a2da60&scoped=true"
import script from "./menu2_active_learning.vue?vue&type=script&lang=js"
export * from "./menu2_active_learning.vue?vue&type=script&lang=js"
import style0 from "./menu2_active_learning.vue?vue&type=style&index=0&id=26a2da60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a2da60",
  null
  
)

export default component.exports